import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ReportApi from "../restapi/reportApi";

const initialState = {
    isLoading: false,
    totalReport: [],
    contactLoaded: {},
    curMessgageId: 0,// id để load chi tiết tin nhắn
    mienDaiCuocId: 3, // ngam dinh la mien nam
    isItemReloading:false
}
// tổng hợp theo contactId, hoặc messageId
export const fetchBasicTotalReport = createAsyncThunk(
    "report/fetchBasicTotalReport",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await ReportApi.FetchBasicTotalReport(payload);
            if (response.errorCode === 0) {
                return response;
            } else {
                return rejectWithValue(response.responseText);
            }
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);
//list tổng hợp từng tin
export const fetchBasicMessageListsReport = createAsyncThunk(
    "report/fetchBasicMessageListsReport",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await ReportApi.FetchBasicMessageListReport(payload);
            if (response.errorCode === 0) {
                return response;
            } else {
                return rejectWithValue(response.responseText);
            }
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);
// AllInOne
export const fetchContactReportAllInOne = createAsyncThunk(
    "report/fetchContactReportAllInOne",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await ReportApi.FetchContactReportAllInOne(payload);
            if (response.errorCode === 0) {
                return response;
            } else {
                return rejectWithValue(response.responseText);
            }
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);
// bao cao tong hop 3 mien
export const fetchContactReport3Mien = createAsyncThunk(
    "report/fetchContactReport3Mien",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await ReportApi.FetchContactReport3Mien(payload);
            if (response.errorCode === 0) {
                return response;
            } else {
                return rejectWithValue(response.responseText);
            }
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);
// chi tiết theo tin nhắn
export const fetchDetailsReport = createAsyncThunk(
    "report/fetchDetailsReport",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await ReportApi.FetchDetailsReportByMessageID(payload);
            if (response.errorCode === 0) {
                return response;
            } else {
                return rejectWithValue(response.responseText);
            }
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);
export const BasicReportSlice = createSlice({
    name: "contact",
    initialState,
    reducers: {
        changeViewType: (state, action) => {
            const { viewType, index } = action.payload
            state.totalReport[index].viewType = viewType
        },
        updateCurMessageId: (state, action) => {
            const { messageId } = action.payload
            state.curMessgageId = messageId
        },
        removeItem: (state, action) => {
            const { index } = action.payload
            state.totalReport.splice(index, 1)
        },
        updateMienDaiCuoc: (state, action) => {
            const { mienDaiCuocId } = action.payload
            state.mienDaiCuocId = mienDaiCuocId
        }
    },
    extraReducers: (builder) => {
        // tổng hợp theo contactId
        builder.addCase(fetchBasicTotalReport.pending, state => {
            state.isItemReloading = true;
        })
        builder.addCase(fetchBasicTotalReport.fulfilled, (state, action) => {
            const data = action.payload.data
            const message = data[0]
            if (message.messageId == 0) {
                if (message.key == 0) {
                    state.totalReport[0] = message
                }
                if (message.key > 0) {
                    for (let i=0;i<state.totalReport.length;i++){
                        const row= state.totalReport[i];
                        if (row.key==message.key){
                            state.totalReport[i]=message;
                        }
                    }
                }
            }


            state.isItemReloading = false;
        })
        builder.addCase(fetchBasicTotalReport.rejected, (state, action) => {
            state.isItemReloading = false;
        })
        //tổng hợp từng tin
        builder.addCase(fetchBasicMessageListsReport.pending, state => {
            state.isLoading = true;
        })
        builder.addCase(fetchBasicMessageListsReport.fulfilled, (state, action) => {
            const data = action.payload.data
            state.isLoading = false;
            if (data) {
                state.totalReport.push(...data)
            }
        })
        builder.addCase(fetchBasicMessageListsReport.rejected, (state, action) => {
            state.isLoading = false;
        })
        //AllInOne
        builder.addCase(fetchContactReportAllInOne.pending, state => {
            state.isLoading = true;
        })
        builder.addCase(fetchContactReportAllInOne.fulfilled, (state, action) => {
            const data = action.payload.data
            state.isLoading = false;
            state.totalReport = []
            if (data) {
                state.totalReport.push(...data)
            }
        })
        builder.addCase(fetchContactReportAllInOne.rejected, (state, action) => {
            state.isLoading = false;
        })
        //3 mien
        builder.addCase(fetchContactReport3Mien.pending, state => {
            state.isLoading = true;
        })
        builder.addCase(fetchContactReport3Mien.fulfilled, (state, action) => {
            const data = action.payload.data
            state.isLoading = false;
            state.totalReport = []
            if (data) {
                state.totalReport.push(...data)
            }
        })
        builder.addCase(fetchContactReport3Mien.rejected, (state, action) => {
            state.isLoading = false;
        })
    },
});



export const { changeViewType, updateCurMessageId, removeItem,
    updateMienDaiCuoc } = BasicReportSlice.actions;
export default BasicReportSlice.reducer;